import JSEncrypt from 'jsencrypt'

let cachedPublicKey: string | null = null

/**
 * 获取 RSA 公钥（带缓存）
 */
export async function fetchPublicKey(apiBaseUrl: string, basePath: string): Promise<string> {
  if (cachedPublicKey) return cachedPublicKey

  const response = await fetch(`${apiBaseUrl}${basePath}/auth/public-key`)
  const result = await response.json()
  if (result.code === 200 && result.data?.publicKey) {
    cachedPublicKey = result.data.publicKey
    return cachedPublicKey!
  }
  throw new Error('获取公钥失败')
}

/**
 * RSA 加密密码
 */
export function encryptPassword(password: string, publicKey: string): string {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  const encrypted = encrypt.encrypt(password)
  if (!encrypted) {
    throw new Error('RSA加密失败')
  }
  return encrypted
}
